import { ValidatedTextFieldProps } from "../Components/Helpers/ValidatedTextField";
import { emailRegex } from "./Helpers";

type ValidationProps = Partial<Pick<ValidatedTextFieldProps, "tests" | "rejectInput">>;

export const a1cValidation: ValidationProps = {
  tests: [
    { test: value => !value || Number(value) < 100, message: "Must be less than 100." },
    { test: value => !value || Number(value) > 0, message: "Must be greater than 0." }
  ],
  rejectInput: value => !/^([0-9]{0,3}\.?[0-9]{0,2})$/.test(value)
};

export const firstNameValidation: ValidationProps = {
  tests: [{ test: value => !value || value.length > 1, message: "Must be longer than 1 character." }]
};

export const lastNameValidation: ValidationProps = {
  tests: [{ test: value => !value || value.length > 1, message: "Must be longer than 1 character." }]
};

export const distanceToCenterValidation: ValidationProps = {
  tests: [{ test: value => !value || Number(value) !== 0, message: "Must be be greater than 0." }],
  rejectInput: value => !/^\d{0,5}$/.test(value)
};

export const emailValidation: ValidationProps = {
  tests: [{ test: value => !value || emailRegex.test(value), message: "Not a recognized email format." }]
};

export const heightFeetValidation: ValidationProps = {
  tests: [{ test: value => !value || Number(value) < 10, message: "Must be less than 10." }],
  rejectInput: value => !/^\d{0,1}$/.test(value)
};

export const heightInchesValidation: ValidationProps = {
  rejectInput: value => !/^(0?|(1[0-1])|([1-9]))$/.test(value)
};

export const weightValidation: ValidationProps = {
  tests: [{ test: value => !value || Number(value) < 1000, message: "Must be less than 1000." }],
  rejectInput: value => !/^([0-9]{0,3}\.?[0-9]{0,2})$/.test(value)
};
